import { ContentfulService } from '../services/contentfulClient';
import TopNavigationMenuItem from './topNavigationMenuEntity';

const contentTypeId = "topNavigationMenuItem";

const fetchTopNavigationMenuItemAsync = (query?: object): Promise<TopNavigationMenuItem[]> => {
  const contentfulClient = new ContentfulService();
  
  return contentfulClient.cdaClient.getEntries(Object.assign({
    content_type: contentTypeId,
    include: 3,
    order: 'fields.id'
  }, query))
  .then(res => res.items)
    .then(mapToTopNavigationMenuItems);
};

const mapToTopNavigationMenuItems = (topNavigationMenuItems: any[]): TopNavigationMenuItem[] => {
  return topNavigationMenuItems.map(mapToTopNavigationMenuItem);
};

const mapToTopNavigationMenuItem = (topNavigationMenuItem: any): TopNavigationMenuItem => {
  const navigationItem = new TopNavigationMenuItem();
  navigationItem.id       = topNavigationMenuItem.fields.id;
  navigationItem.linkText = topNavigationMenuItem.fields.linkText;
  navigationItem.linkUrl  = '';                                      // default

  /* ---------- build linkUrl ---------- */
  if (topNavigationMenuItem.fields.contentPage) {
    const page = topNavigationMenuItem.fields.contentPage.fields;
    const baseUrl = page.breadcrumbsPath && page.breadcrumbsPath.fields && page.breadcrumbsPath.fields.relativePath ? page.breadcrumbsPath.fields.relativePath : '';
    navigationItem.linkUrl = baseUrl + page.friendlyUrl; // e.g. '/sertifikaatit'
  } else {
    navigationItem.linkUrl = topNavigationMenuItem.fields.linkUrl || '';
  }

  if (topNavigationMenuItem.fields.urlTarget) {
    navigationItem.urlTarget = topNavigationMenuItem.fields.urlTarget;
  }

  if (topNavigationMenuItem.fields.subMenuItems && topNavigationMenuItem.fields.subMenuItems.length > 0) {
    navigationItem.subMenuItems = mapToTopNavigationMenuItems(
      topNavigationMenuItem.fields.subMenuItems
    );
  }

  /* ---------- normalise to absolute internal path ---------- */
  if (navigationItem.linkUrl) {
    const external = navigationItem.linkUrl.startsWith('http') || navigationItem.linkUrl.startsWith('//');
    if (!external && !navigationItem.linkUrl.startsWith('/')) {
      navigationItem.linkUrl = '/' + navigationItem.linkUrl;
    }
  }

  return navigationItem;
};

export const topNavigationMenuItemAPI = {
  fetchTopNavigationMenuItemAsync
};


// WEBPACK FOOTER //
// ./src/api/topNavigationMenuAPI.ts